export default __webpack_public_path__ + "static/tech-data-bg-cb8176eaf5eee4c90f5b49b9cae0b36e.webp";